module.exports = __webpack_public_path__ + "img/adhaar.3a2cb5e1.png";